(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EPSILON = 1;
    const SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');

    /**
     * Match theme scroll-container: desktop uses `.page-wrapper`, mobile uses the document.
     * @returns {Element}
     */
    function getPageScrollContainer() {
      if (SQUEEZE_QUERY.matches) {
        return document.querySelector('.page-wrapper') ?? document.scrollingElement ?? document.documentElement;
      }
      return document.scrollingElement ?? document.documentElement;
    }

    /**
     * @param {number} deltaY
     */
    function scrollPageBy(deltaY) {
      getPageScrollContainer().scrollBy({ top: deltaY, left: 0, behavior: 'instant' });
    }

    /**
     * Forward vertical wheel to the page once the table can't scroll further
     * in that direction (or has no vertical overflow of its own).
     * @param {WheelEvent} event
     */
    function handleWheel(event) {
      const scrollEl = /** @type {HTMLElement} */ (event.currentTarget);
      const deltaY = event.deltaY;

      if (deltaY === 0) return;

      const maxScrollTop = scrollEl.scrollHeight - scrollEl.clientHeight;
      const canScrollY = maxScrollTop > EPSILON;
      const scrollingDown = deltaY > 0;

      if (!canScrollY) {
        event.preventDefault();
        scrollPageBy(deltaY);
        return;
      }

      const atTop = scrollEl.scrollTop <= EPSILON;
      const atBottom = scrollEl.scrollTop >= maxScrollTop - EPSILON;

      if ((scrollingDown && atBottom) || (!scrollingDown && atTop)) {
        event.preventDefault();
        scrollPageBy(deltaY);
      }
    }

    /**
     * @param {ParentNode} [root]
     */
    function bind(root = document) {
      root.querySelectorAll('[data-comparison-scroll]').forEach((el) => {
        if (!(el instanceof HTMLElement) || el.dataset.scrollBound === 'true') return;
        el.dataset.scrollBound = 'true';
        el.addEventListener('wheel', handleWheel, { passive: false });
      });
    }

    bind();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) bind(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsWebinarKlaviyo) return;
  window.__bsWebinarKlaviyo = true;

  document.querySelectorAll('[data-lp-signup]').forEach(function (form) {
    var key = form.getAttribute('data-klaviyo-key');
    var list = form.getAttribute('data-klaviyo-list');
    var btn = form.querySelector('[data-lp-signup-btn]');
    var card = form.parentElement;
    var ok = card ? card.querySelector('[data-lp-signup-success]') : null;
    var exists = card ? card.querySelector('[data-lp-signup-exists]') : null;
    var err = card ? card.querySelector('[data-lp-signup-error]') : null;
    var original = btn ? btn.innerHTML : '';

    function restoreButton() {
      form.dataset.submitting = 'false';
      if (!btn) return;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.innerHTML = original;
    }

    function legacySubscribe(email, firstName, lastName) {
      var body = new URLSearchParams();
      body.set('g', list);
      body.set('email', email);
      body.set('$fields', '$source,first_name,last_name');
      body.set('$source', 'Blushield Webinar Page');
      body.set('first_name', firstName);
      body.set('last_name', lastName);
      return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (res) { return res.json(); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.dataset.submitting === 'true') return;
      if (!key || !list) return;
      if (!form.reportValidity()) return;

      form.dataset.submitting = 'true';
      if (err) err.hidden = true;
      if (exists) exists.hidden = true;
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Sending…';
      }

      var email = form.email.value.trim();
      var firstName = form.first_name.value.trim();
      var lastName = form.last_name.value.trim();

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Blushield Webinar Page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: firstName,
                  last_name: lastName,
                  properties: {
                    webinar_source: 'Blushield Webinar Page',
                    webinar_session_date: form.getAttribute('data-session-date') || '',
                    webinar_session_time: form.getAttribute('data-session-time') || ''
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };

      function clientSubscribe() {
        return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          if (res.status !== 202) throw new Error('HTTP ' + res.status);
          form.hidden = true;
          if (ok) ok.hidden = false;
        });
      }

      legacySubscribe(email, firstName, lastName).then(function (data) {
        if (data && data.success === true && data.data && data.data.is_subscribed === true) {
          form.hidden = true;
          if (exists) exists.hidden = false;
          return;
        }
        if (data && data.success === true) {
          form.hidden = true;
          if (ok) ok.hidden = false;
          return;
        }
        return clientSubscribe();
      }, function () {
        return clientSubscribe();
      }).catch(function () {
        restoreButton();
        if (err) err.hidden = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__bsNewsletterKlaviyo) return;
    window.__bsNewsletterKlaviyo = true;

    var messages = {
      success: 'Thanks for subscribing!',
      exists: "You're already subscribed.",
      error: 'Something went wrong. Please try again.'
    };

    function showMessage(form, text) {
      var box = form.querySelector('[data-klaviyo-message]');
      if (!box) {
        box = document.createElement('p');
        box.className = 'email-signup__message';
        box.setAttribute('data-klaviyo-message', '');
        box.setAttribute('role', 'status');
        form.appendChild(box);
      }
      box.textContent = text;
    }

    function legacySubscribe(listId, email) {
      var body = new URLSearchParams();
      body.set('g', listId);
      body.set('email', email);
      body.set('$fields', '$source');
      body.set('$source', 'Newsletter banner');
      return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body
      }).then(function (res) { return res.json(); });
    }

    function clientSubscribe(key, listId, email) {
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Newsletter banner',
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status !== 202) throw new Error('HTTP ' + res.status);
      });
    }

    function bindBannerForms() {
      document.querySelectorAll('.newsletter-banner form').forEach(function (form) {
        form.setAttribute('action', 'javascript:void(0)');
        form.removeAttribute('method');
      });
    }

    bindBannerForms();
    document.addEventListener('shopify:section:load', bindBannerForms);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.closest) return;

      var banner = form.closest('.newsletter-banner');
      if (!banner) return;

      event.preventDefault();
      event.stopPropagation();

      if (form.dataset.submitting === 'true') return;

      var key = form.getAttribute('data-klaviyo-key') || banner.getAttribute('data-klaviyo-key');
      var listId = form.getAttribute('data-klaviyo-list') || banner.getAttribute('data-klaviyo-list');
      if (!key || !listId) return;

      var input = form.querySelector('input[type="email"]');
      if (input) input.value = (input.value || '').trim();
      if (input && !input.checkValidity()) {
        input.reportValidity();
        return;
      }

      var email = input ? input.value : '';
      var button = form.querySelector('[type="submit"], button');
      if (!email) return;

      form.dataset.submitting = 'true';
      var originalLabel = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = 'Subscribing…';
      }
      if (input) input.disabled = true;

      function finish() {
        form.dataset.submitting = 'false';
        if (input) input.disabled = false;
        if (!button) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.innerHTML = originalLabel;
      }

      function subscribeNew() {
        return clientSubscribe(key, listId, email).then(function () {
          showMessage(form, messages.success);
          if (input) input.value = '';
        });
      }

      legacySubscribe(listId, email).then(function (data) {
        if (data && data.success === true && data.data && data.data.is_subscribed === true) {
          showMessage(form, messages.exists);
          return;
        }
        if (data && data.success === true) {
          showMessage(form, messages.success);
          if (input) input.value = '';
          return;
        }
        return subscribeNew();
      }, function () {
        return subscribeNew();
      }).catch(function () {
        showMessage(form, messages.error);
      }).then(finish);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !Shopify.designMode) return;
  try {
    
  class ProductContentNav extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('[data-product-content-nav]');
      this.toggle = this.querySelector('[data-product-content-nav-toggle]');
      this.labelEl = this.querySelector('[data-product-content-nav-label]');

      this.formatSetupSteps();
      this.rebuildNavFromPanels();

      this.links = Array.from(this.querySelectorAll('[data-product-content-link]'));
      this.panels = this.links
        .map((link) => document.getElementById(link.dataset.target))
        .filter(Boolean);

      if (!this.links.length || !this.panels.length) {
        this.nav?.remove();
        return;
      }

      this.links.forEach((link) => link.classList.remove('is-active'));
      this.links[0]?.classList.add('is-active');
      this.syncToggleLabel(this.links[0]);

      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onToggle = this.onToggle.bind(this);
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onResize = this.onResize.bind(this);

      this.scrollContainer = document.querySelector('.page-wrapper') || window;

      this.links.forEach((link) => link.addEventListener('click', this.onClick));
      this.toggle?.addEventListener('click', this.onToggle);
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
      this.scrollContainer.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      this.updateActiveFromScroll();
    }

    formatSetupSteps() {
      this.querySelectorAll('.product-content__setup:not(.product-content__expect) li').forEach((item) => {
        if (item.querySelector('.product-content__setup-copy')) return;

        const titleEl = item.querySelector('strong, b');
        let title = '';

        if (titleEl) {
          title = titleEl.textContent.replace(/\s+/g, ' ').trim();
          const titleParent = titleEl.parentElement;
          titleEl.remove();
          if (titleParent && titleParent !== item && !titleParent.textContent.trim()) titleParent.remove();
        }

        const holder = document.createElement('div');
        holder.innerHTML = item.innerHTML;
        const firstText = document.createTreeWalker(holder, NodeFilter.SHOW_TEXT).nextNode();
        if (firstText) firstText.textContent = firstText.textContent.replace(/^\s*[—–-]\s*/, '');
        holder.querySelectorAll('p').forEach((paragraph) => {
          if (!paragraph.textContent.trim()) paragraph.remove();
        });

        let detailHtml = holder.innerHTML.trim();
        let detailText = holder.textContent.replace(/\s+/g, ' ').trim();

        if (!title) {
          const source = detailText;
          const splitAt = source.search(/\s+[—–]\s+/);
          if (splitAt > 0) {
            title = source.slice(0, splitAt).trim();
            detailText = source.slice(splitAt).replace(/^\s*[—–]\s*/, '').trim();
            detailHtml = '';
          }
        }

        item.replaceChildren();
        const copy = document.createElement('div');
        copy.className = 'product-content__setup-copy';

        if (title) {
          const titleNode = document.createElement('p');
          titleNode.className = 'product-content__setup-title';
          titleNode.textContent = title;
          copy.appendChild(titleNode);
        }

        if (detailText) {
          const detailNode = document.createElement('div');
          detailNode.className = 'product-content__setup-detail';
          if (detailHtml) detailNode.innerHTML = detailHtml;
          else detailNode.textContent = detailText;
          copy.appendChild(detailNode);
        }

        item.appendChild(copy);
      });
    }

    rebuildNavFromPanels() {
      this.querySelectorAll('[data-product-content-panels] > *').forEach((wrap) => {
        wrap.hidden = !wrap.querySelector('[data-product-content-panel]');
      });

      const list = this.querySelector('[data-product-content-nav-list]');
      const panels = Array.from(this.querySelectorAll('[data-product-content-panel]'));
      if (!list || !panels.length) return;

      list.innerHTML = '';

      panels.forEach((panel, index) => {
        const heading = panel.querySelector('.product-content__heading');
        const label =
          panel.getAttribute('data-nav-label') ||
          heading?.textContent?.trim() ||
          'Section';

        const item = document.createElement('li');
        item.className = 'product-content__nav-item';

        const link = document.createElement('a');
        link.className = 'product-content__nav-link' + (index === 0 ? ' is-active' : '');
        link.href = `#${panel.id}`;
        link.dataset.productContentLink = '';
        link.dataset.target = panel.id;
        link.textContent = label;

        item.appendChild(link);
        list.appendChild(item);
      });

      this.syncToggleLabel(list.querySelector('.product-content__nav-link.is-active'));
    }

    disconnectedCallback() {
      this.links?.forEach((link) => link.removeEventListener('click', this.onClick));
      this.toggle?.removeEventListener('click', this.onToggle);
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
      this.scrollContainer?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.cancelAnimationFrame(this.scrollFrame);
    }

    onToggle(event) {
      event.preventDefault();
      event.stopPropagation();
      this.setOpen(!this.nav?.classList.contains('is-open'));
    }

    onDocumentClick(event) {
      if (!this.nav?.classList.contains('is-open')) return;
      if (this.nav.contains(event.target)) return;
      this.setOpen(false);
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.setOpen(false);
    }

    setOpen(open) {
      if (!this.nav) return;
      this.nav.classList.toggle('is-open', open);
      this.toggle?.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    syncToggleLabel(link) {
      if (!this.labelEl || !link) return;
      this.labelEl.textContent = link.textContent.trim();
    }

    onClick(event) {
      const link = event.currentTarget;
      const target = document.getElementById(link.dataset.target);
      if (!target) return;
      event.preventDefault();
      this.setOpen(false);
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.setActive(link.dataset.target);
    }

    onScroll() {
      window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = window.requestAnimationFrame(() => this.updateActiveFromScroll());
    }

    onResize() {
      this.updateActiveFromScroll();
    }

    getActivationLineY() {
      // How far from the top of the viewport the "you are now in this section" line sits.
      // Use header height + a small extra offset so the section is clearly in view.
      const headerHeight =
        parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
      // On mobile the sticky nav bar takes extra vertical space too.
      const mobileNavHeight =
        window.innerWidth < 990 ? (this.nav?.offsetHeight || 0) : 0;
      // 140px extra so the section activates when its heading is still comfortably visible.
      return headerHeight + mobileNavHeight + 140;
    }

    updateActiveFromScroll() {
      if (!this.panels?.length) return;

      const lineY = this.getActivationLineY();
      // Walk panels in order; activate the last one whose top edge is above lineY.
      // Default to the first panel so something is always active.
      let activePanel = this.panels[0];

      for (const panel of this.panels) {
        const rect = panel.getBoundingClientRect();
        if (rect.top <= lineY) {
          activePanel = panel;
        }
      }

      this.setActive(activePanel.id);
    }

    setActive(id) {
      let activeLink = null;
      this.links.forEach((link) => {
        const isActive = link.dataset.target === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) activeLink = link;
      });
      this.syncToggleLabel(activeLink);
    }
  }

  if (!customElements.get('product-content-nav')) {
    customElements.define('product-content-nav', ProductContentNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-range-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const EPSILON = 1;
    const SQUEEZE_QUERY = window.matchMedia('(min-width: 990px)');

    function getPageScrollContainer() {
      if (SQUEEZE_QUERY.matches) {
        return document.querySelector('.page-wrapper') ?? document.scrollingElement ?? document.documentElement;
      }
      return document.scrollingElement ?? document.documentElement;
    }

    function scrollPageBy(deltaY) {
      getPageScrollContainer().scrollBy({ top: deltaY, left: 0, behavior: 'instant' });
    }

    function handleWheel(event) {
      const scrollEl = /** @type {HTMLElement} */ (event.currentTarget);
      const deltaY = event.deltaY;
      if (deltaY === 0) return;

      const maxScrollTop = scrollEl.scrollHeight - scrollEl.clientHeight;
      const canScrollY = maxScrollTop > EPSILON;
      const scrollingDown = deltaY > 0;

      if (!canScrollY) {
        event.preventDefault();
        scrollPageBy(deltaY);
        return;
      }

      const atTop = scrollEl.scrollTop <= EPSILON;
      const atBottom = scrollEl.scrollTop >= maxScrollTop - EPSILON;

      if ((scrollingDown && atBottom) || (!scrollingDown && atTop)) {
        event.preventDefault();
        scrollPageBy(deltaY);
      }
    }

    function bind(root = document) {
      root.querySelectorAll('[data-comparison-scroll]').forEach((el) => {
        if (!(el instanceof HTMLElement) || el.dataset.scrollBound === 'true') return;
        el.dataset.scrollBound = 'true';
        el.addEventListener('wheel', handleWheel, { passive: false });
      });
    }

    bind();
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) bind(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const formatDuration = (seconds) => {
      if (!Number.isFinite(seconds) || seconds <= 0) return '';
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${minutes}:${String(secs).padStart(2, '0')}`;
    };

    const updateDuration = (root) => {
      const el = root.querySelector('[data-video-showcase-duration]');
      if (!el) return;

      const fallback = el.dataset.fallback || '';
      const video = root.querySelector('video');

      if (video) {
        const apply = () => {
          const formatted = formatDuration(video.duration);
          if (formatted) el.textContent = formatted;
          else if (fallback) el.textContent = fallback;
        };

        if (video.readyState >= 1) apply();
        else video.addEventListener('loadedmetadata', apply, { once: true });
      } else if (fallback && !el.textContent.trim()) {
        el.textContent = fallback;
      }
    };

    const initSection = (root) => {
      if (!(root instanceof HTMLElement)) return;
      updateDuration(root);
      root.addEventListener('click', (event) => {
        if (event.target.closest('.video-showcase__poster-button, .video-showcase__toggle')) {
          window.setTimeout(() => updateDuration(root), 350);
        }
      });
    };

    document.querySelectorAll('.video-showcase').forEach(initSection);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector?.('.video-showcase');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
